import { FC } from 'react';
import { useNavigate } from 'react-router';
import { DeleteStreamModalContent } from '@/components/streams/delete-stream/delete-stream-modal-content.tsx';
import { paths } from '@/routes-utils/paths.ts';
import { useDeleteStream } from './use-delete-stream.ts';

export type DeleteStreamWrapperProps = {
  streamId: string;
  onCancel: () => void;
  isPaidStream: boolean;
};

export const DeleteStreamWrapper: FC<DeleteStreamWrapperProps> = ({
  onCancel,
  streamId,
  isPaidStream,
}) => {
  const navigate = useNavigate();
  const [deleteStream] = useDeleteStream(streamId);

  const onDelete = () => {
    deleteStream();
    navigate(paths.streams);
  };

  return (
    <DeleteStreamModalContent
      isPaid={isPaidStream}
      onDelete={onDelete}
      onCancel={onCancel}
      entityName={'data stream'}
    />
  );
};
